import React from 'react'

import { StatusIndicator } from '@octane/spark'

import { Field } from './ValidationsField.styled'

export interface Validations {
    hasSymbols: boolean | null
    passwordsMatch: boolean | null
    hasMinCharacters: boolean | null
    hasNumbers: boolean | null
    hasLowerUpper: boolean | null
}

interface Props {
    validations: Validations
}

export default function ValidationsField({ validations }: Props): JSX.Element {
    function checkState(isValid: boolean | null) {
        if (isValid === null) return 'noStatus'

        return isValid ? 'complete' : 'error'
    }

    return (
        <Field>
            <StatusIndicator
                iconPosition="left"
                id="characters"
                text="Use at least 8 characters"
                variant={checkState(validations.hasMinCharacters)}
                data-state={checkState(validations.hasMinCharacters)}
            />
            <StatusIndicator
                iconPosition="left"
                id="upperAndLower"
                text="Use upper and lower case letters"
                variant={checkState(validations.hasLowerUpper)}
                data-state={checkState(validations.hasLowerUpper)}
            />
            <StatusIndicator
                iconPosition="left"
                id="numbers"
                text="Use 1 or more numbers"
                variant={checkState(validations.hasNumbers)}
                data-state={checkState(validations.hasNumbers)}
            />
            <StatusIndicator
                iconPosition="left"
                id="symbols"
                text="Use at least 1 symbol -!$%^*()_+|~+?"
                variant={checkState(validations.hasSymbols)}
                data-state={checkState(validations.hasSymbols)}
            />
            <StatusIndicator
                iconPosition="left"
                id="match"
                text="Passwords match"
                variant={checkState(validations.passwordsMatch)}
                data-state={checkState(validations.passwordsMatch)}
            />
        </Field>
    )
}
